/**
 * see ./docs/using-beta-features-with-auth.md for additional detail
 *
 * As of this writing, there are currently 3 different types of beta feature flags
 * - The "machine level feature flag". This flag is user agnostic and any user that opts-in using it will opt any and all users of that machine into that feature (BEWARE)
 * - The 'launch darkly feature flag". This flag is currently read-only but can resolve any existing flag (that is exposed at the client level). If required, it would be possible to implement the "opt in" portion of this flag.
 * - The "local user feature flag". This flag does not support anonymous usage. Its state can only be set and resolved when a user is logged in.
 *
 * This opt in system is designed especially for auth where we may need to infer user context before login. As such, it is permissible to check if a user is opted in before login (some beta flags also allow for setting opt-in before login)
 *
 * TO ADD A NEW BETA FEATURE
 * - Add a new and unique `BETA_FEATURE_*` constant below
 *  - If the flag will be a Launch Darkly flag type, the value of the new feature const must also match the ID of the flag in Launch Darkly.
 * - Add a new entry in the `activeBetaFeatures` array. This is where you'll specify the flag type (either `OPT_IN_TYPE_MACHINE_LEVEL`, `OPT_IN_TYPE_USER_LEVEL` or `OPT_IN_TYPE_FEATURE_FLAG`)
 * - Finally, export the feature UD so that other parts of the code can reliably reference the feature. If the beta feature is to be referenced in another app (e.g. v3), then add a constant for it to the `Auth0BetaOptInHelper` class. Example
 *
 *   get BETA_FEATURE_MY_NEW_FEATURE_AVAILABLE_ID() {
 *     return BETA_FEATURE_MY_NEW_FEATURE_AVAILABLE;
 *   }
 *
 * TO CHECK IF A USER IS OPTED IN TO A BETA FEATURE
 * - In code, wherever is appropriate to make a decision regarding showing / hiding, enabling / disabling etc, instantiate a new instance of the `Auth0BetaOptInHelper` class.
 * - Using this object, simply call `Auth0BetaOptInHelper.isOptedIn(featureId)` where `featureId` is the exported `BETA_FEATURE_*` from this file.
 * - Apply the resolved opt in value to your feature
 *
 * ex:
 * import { BETA_FEATURE_MY_NEW_FEATURE_ENABLED } from '../../utils/beta-opt-in/auth0-active-beta-features-config.mjs';
 * ...
 * this.shouldMyFeatureBeVisible = await this._optInHelper.isOptedIn(BETA_FEATURE_MY_NEW_FEATURE_ENABLED); // Note: _optInHelper is available to all cdn auth pages
 * console.log(`Checked beta opt in state for ${BETA_FEATURE_MY_NEW_FEATURE_ENABLED} => ${this.shouldMyFeatureBeVisible}`);
 * ...
 *
 *
 * TO OPT A USER IN TO A BETA FEATURE
 * - In code, wherever is appropriate for a user or code to make a decision regarding opting-in to a feature, instantiate a new instance of the `Auth0BetaOptInHelper` class.
 * - Using this object, simply call `Auth0BetaOptInHelper.optIn(featureId)` where `featureId` is the exported `BETA_FEATURE_*` from this file.
 *
 * TO OPT A USER OUT OF A BETA FEATURE
 * - In code, wherever is appropriate for a user or code to make a decision regarding opting-out of a feature, instantiate a new instance of the `Auth0BetaOptInHelper` class.
 * - Using this object, simply call `Auth0BetaOptInHelper.optOut(featureId)` where `featureId` is the exported `BETA_FEATURE_*` from this file.
 *
 * TO REMOVE A (COMPLETED) BETA FEATURE
 * - Assuming the exported `BETA_FEATURE_*` ID was used for all access to the feature, a search for it should yield all references to the feature that need removal.
 * - Remove it from this file (see "TO ADD A NEW BETA FEATURE" above and do the reverse)
 * - Remove any in-code references to the old `BETA_FEATURE_*` for opt-in checks with `Auth0BetaOptInHelper.isOptedIn(featureId)` (i.e. either permanently enable or remove the feature)
 * - Remove any in-code references to the old `BETA_FEATURE_*` for setting opt-in state using with `Auth0BetaOptInHelper.optIn(featureId)`
 * - Remove any in-code references to the old `BETA_FEATURE_*` for setting opt-out state using with `Auth0BetaOptInHelper.optOut(featureId)`
 * - Remove any getter vars added to `Auth0BetaOptInHelper`
 */
const OPT_IN_TYPE_MACHINE_LEVEL = 0;
const OPT_IN_TYPE_FEATURE_FLAG = 1;
const OPT_IN_TYPE_USER_LEVEL = 2;

// Here is an example of a beta feature flag that uses:
// - LaunchDarkly to determine of a user CAN opt in
// - Machine level opt-in to determine if the user IS opted in
//
// Continue example in auth0-beta-opt-in-helper.mjs file...

// const BETA_FEATURE_MY_NEW_FEATURE_AVAILABLE = 'auth0-sso-account-linking-available';
// const BETA_FEATURE_MY_NEW_FEATURE_ENABLED = 'auth0-sso-account-linking-enabled';

const activeBetaFeatures = [
  // Add the LD flag... (THIS ID MUST MATCH THE LD ID!!!!!)
  // { featureId: BETA_FEATURE_MY_NEW_FEATURE_AVAILABLE, type: OPT_IN_TYPE_FEATURE_FLAG },
  // ...and the machine level opt-in
  // { featureId: BETA_FEATURE_MY_NEW_FEATURE_ENABLED, type: OPT_IN_TYPE_MACHINE_LEVEL },
];

export {
  activeBetaFeatures,
  OPT_IN_TYPE_MACHINE_LEVEL,
  OPT_IN_TYPE_FEATURE_FLAG,
  OPT_IN_TYPE_USER_LEVEL,
  // export the new feature IDs so we can refer to them in other parts of the code
  // BETA_FEATURE_MY_NEW_FEATURE_AVAILABLE,
  // BETA_FEATURE_MY_NEW_FEATURE_ENABLED,
};
